<div class="info_step">
  <div class="info_step_item_block">
    <app-user-profile-usage></app-user-profile-usage>
  </div>
  <div class="info_step_item_block">
    <app-opt-out [options]="stepAccount.outOptions" (optionsChanged)="optionChanged()"></app-opt-out>
  </div>
  <hr />
  <div class="info_step_item_block">
    <app-service-terms
      [pdfLanguage]="stepAccount?.pdfLanguage"
      (pdfLanguageChanged)="onPdfLanguageChanged($event)"
    ></app-service-terms>
  </div>
  <div>
    <label class="info_step_custom_checkbox"
      >{{ 'MyProfile_GDPR_AcceptTerms' | translate }}
      <input type="checkbox" [(ngModel)]="stepAccount.isAcceptedTerms" (change)="termsAcceptingChanged()" />
      <span class="info_step_custom_checkbox_checkmark"></span>
    </label>
  </div>
</div>
